import { ABExperiment, ABTestStatus, UserCountry } from '@models/abTest/experiment';

export const EABExperiments = {
  ScoreCopy: {
    experimentId: 'score_copy',
    variantId1: 'emotional',
    variantId2: 'operational',
  },
} as const;

export const AB_EXPERIMENTS: ABExperiment[] = [
  {
    id: 'score_copy',
    name: 'Score Copy',
    status: ABTestStatus.ACTIVE,
    targetingConditions: {
      country: [UserCountry.SPARTACUS],
      segments: [],
      customProperties: [],
    },
    enrollement: () => {},
    variants: [
      {
        id: 'emotional',
        name: 'Emotional',
        percentage: 50,
      },
      {
        id: 'operational',
        name: 'Operational',
        percentage: 50,
      },
    ],
  },
  /*  
  {
    id: 'Review',
    name: 'Review',
    status: ABTestStatus.ACTIVE,
    targetingConditions: {
      country: [UserCountry.SPARTACUS],
      segments: [],
      customProperties: [{ prop: 'JooiceFlow', value: 'REVIEW' }],
    },
    enrollement: () => {},
    variants: [
      {
        id: 'var_review',
        name: 'var_review',
        percentage: 100,
      },
    ],
  },
  {
    id: 'Social',
    name: 'Social',
    status: ABTestStatus.ACTIVE,
    targetingConditions: {
      country: [UserCountry.SPARTACUS],
      segments: [],
      customProperties: [{ prop: 'JooiceFlow', value: 'SOCIAL' }],
    },
    enrollement: () => {},
    variants: [
      {
        id: 'var_social',
        name: 'var_social',
        percentage: 100,
      },
    ],
  },*/
] as const;

/*
HOW TO CREATE A NEW EXPERIMENT:

  {
    id: 'test',
    name: 'Test',
    status: ABTestStatus.ACTIVE,
    targetingConditions: {
      country: [UserCountry.USA],
      segments: ['ExperimentTest'],
      customProperties: [{prop: value}],
    },
    enrollement: (variantName: string) => {
      // side effects on enrolment, if the experiment needs any
    },
    variants: [
      {
        id: 'ctrl',
        name: 'Control',
        percentage: 50,
      },
      {
        id: 'var',
        name: 'Variant',
        percentage: 50,
      },
    ],
  }
*/
